import React from "react";
import AutomobileComp from "../../component/solutionscomponent/AutomobileComp";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";

const AutoMobile = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <AutomobileComp />
        <Footer />
      </section>
    </>
  );
};

export default AutoMobile;
